var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7287_39726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4856 20.4856C24.9861 15.9851 25.1638 8.79988 21.0206 4.08618L12 11.9999L4.08618 21.0206C8.79988 25.1638 15.9851 24.9861 20.4856 20.4856Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51438 3.5144C8.01488 -0.986107 15.2001 -1.16381 19.9138 2.97942L12 12.0001L2.97944 19.9138C-1.16383 15.2001 -0.986083 8.01491 3.51438 3.5144Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9136 2.97937L2.97925 19.9138C3.15044 20.1085 3.32818 20.2996 3.51423 20.4856C3.70023 20.6716 3.89134 20.8493 4.08615 21.0206L21.0204 4.08618C20.8492 3.89137 20.6714 3.70031 20.4854 3.51426C20.2995 3.32835 20.1084 3.15056 19.9136 2.97937Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05594 4.17355L5.31502 4.97075H6.15319L5.4751 5.46336L5.73408 6.26057L5.05594 5.76786L4.3778 6.26057L4.63688 5.46336L3.95874 4.97075H4.79696L5.05594 4.17355Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33744 4.17355L9.59651 4.97075H10.4346L9.75654 5.46336L10.0156 6.26057L9.33744 5.76786L8.6593 6.26057L8.91837 5.46336L8.24023 4.97075H9.0784L9.33744 4.17355Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05594 8.34763L5.31502 9.14483H6.15319L5.4751 9.63748L5.73408 10.4347L5.05594 9.94198L4.3778 10.4347L4.63688 9.63748L3.95874 9.14483H4.79696L5.05594 8.34763Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33744 8.34763L9.59651 9.14483H10.4346L9.75654 9.63748L10.0156 10.4347L9.33744 9.94198L8.6593 10.4347L8.91837 9.63748L8.24023 9.14483H9.0784L9.33744 8.34763Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19661 6.26056L7.45569 7.05776H8.29381L7.61572 7.55042L7.87475 8.34762L7.19661 7.85492L6.51847 8.34762L6.7775 7.55042L6.09937 7.05776H6.93758L7.19661 6.26056Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7287_39726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/sb.2d76058e98e39b6b2fb5e634c6bb111f.svg";
export { ForwardRef as ReactComponent };